import React from "react";
import { Flex } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { getFieldValuesForSection } from "../../utils/dataTransformers";
import { SectionView } from "./SectionView";
import type { SectionWithFields } from "../../../CustomFields/types";
import type { EntityExtensionFieldValue } from "../../types";

export type SectionsViewProps = {
  sectionsWithFields: SectionWithFields[];
  fieldValuesMap: Map<string, EntityExtensionFieldValue>;
  onFieldChange: (fieldId: string, value: string) => void;
};

export const SectionsView: React.FC<SectionsViewProps> = ({
  sectionsWithFields,
  fieldValuesMap,
  onFieldChange,
}) => {
  return (
    <Flex flexDirection="column" gap={SPACING.MEDIUM}>
      {sectionsWithFields.map((sectionWithFields) => {
        const fieldValues = getFieldValuesForSection(sectionWithFields.fields, fieldValuesMap);
        if (fieldValues.length === 0) return null;
        return (
          <SectionView
            key={sectionWithFields.section.id}
            section={sectionWithFields.section}
            fields={fieldValues}
            onFieldChange={onFieldChange}
          />
        );
      })}
    </Flex>
  );
};
